import React, { useState } from 'react';

import { makeUrl, endpoints } from "./endpoints.js";

function Licenses() {
  const defaultFormData = {Email: ""};
  const [formData, setFormData] = useState(defaultFormData);
  const [formReadOnly, setFormReadOnly] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if(!formData.Email) {
      return;
    }

    setFormReadOnly(true);

    fetch(makeUrl(endpoints.buykey), {method: 'POST', body: JSON.stringify(formData)})
      .then(res => {
        if (!res.ok) {
          throw new Error(`HTTP error! Status: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        setFormData(defaultFormData)
        window.location.href = data._links.checkout.href;
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setFormReadOnly(false);
      });
  }

  return (
    <div className="container block is-max-desktop">
      <div className="container block">
        <h3 className="has-text-weight-bold is-size-3 honey-text-font-family-common honey-text-common">
          Licenses Temp
        </h3>
      </div>
      <form action="" className="box">
        <div className="field">
          <label className="label">Email</label>
          <input
            className="input"
            type="text"
            name="Email"
            placeholder="Email"
            readOnly={formReadOnly}
            value={formData.Email}
            onChange={handleChange}
          />
        </div>
        <div className="field">
          <button className="button honey-button" onClick={handleSubmit} disabled={formReadOnly}>Login</button>
        </div>
      </form>
    </div>
  );
}

export default Licenses;
